export default "__VITE_ASSET__DjDHMPme__"